import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    OnDestroy,
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LinkService, LinkStats} from '../../shared/link/link.service';
import {BehaviorSubject, Subscription} from 'rxjs';
import {WorkspacesService} from '@common/workspaces/workspaces.service';
import {skip} from 'rxjs/operators';

@Component({
    selector: 'dashboard-home',
    templateUrl: './dashboard-home.component.html',
    styleUrls: ['./dashboard-home.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardHomeComponent implements OnInit, OnDestroy {
    public reports$ = new BehaviorSubject<LinkStats>(null);
    private workspaceSub: Subscription;

    constructor(
        private route: ActivatedRoute,
        private workspaces: WorkspacesService,
        private links: LinkService
    ) {}

    ngOnInit() {
        this.route.data.subscribe((data: {reports: LinkStats}) => {
            this.reports$.next(data.reports);
        });

        this.workspaceSub = this.workspaces.activeId$
            .pipe(skip(1))
            .subscribe(() => {
                this.links.getCurrentUserReports().subscribe(response => {
                    this.reports$.next(response.analytics);
                });
            });
    }

    ngOnDestroy() {
        this.workspaceSub.unsubscribe();
    }
}
